<div class="toggle" [class.active]="visible" (click)="toggle()"></div>

<div class="content">

  <section class="documentsTypesContainer" *ngFor="let document of documentsTypes">
    <div class="documentsTypeName">
      <a class="colored" routerLink="/{{document.type}}"
        [ngClass]="{'active': activeDocumentsComponent && document.serviceType === serviceType}">
        {{document.title}}
      </a>
      <div class="statistics" *ngIf="showStatistics(document)" [uiTooltip]="demoApplications" uiTooltipPosition="left">
        <span>{{pageCount}}/{{limit}}</span>
      </div>
      <ui-loader class="loader" *ngIf="!demoApplications && serviceType === document.serviceType"></ui-loader>
    </div>
    <div class="developersSection" [hidden]="!showDevelopersSettings(document.serviceType)">
      <div>
        <div class="developersListItem">
          <a class="colored icon" routerLink="/{{document.type}}/quick-start-guide" routerLinkActive="active">
            <ui-lens-beacon name="guide"></ui-lens-beacon>
            <svg-icon src="/assets/icons/info.svg"></svg-icon>
            <span>API Quick Start Guide</span>
          </a>
        </div>
        <div class="developersListItem">
          <a class="colored icon" routerLink="/{{document.type}}/api-description" routerLinkActive="active">
            <svg-icon src="/assets/icons/mode-table.svg"></svg-icon>
            <span>API Description</span>
          </a>
        </div>
        <div class="developersListItem">
          <a class="colored icon" routerLink="/{{document.type}}/applications" routerLinkActive="active">
            <ui-lens-beacon name="guide"></ui-lens-beacon>
            <svg-icon src="/assets/icons/apps.svg"></svg-icon>
            <span>Applications</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="bordered" *ngIf="userIsAdmin() && userIsServiceAdmin()">
    <h5 *ngIf=" userIsServiceAdmin()">Service administration</h5>
    <div *ngIf="userIsServiceAdmin()">
      <a class="colored icon" routerLink="/admin/applications" routerLinkActive="active">
        <svg-icon src="/assets/icons/settings.svg"></svg-icon>
        <span>Applications</span>
      </a>
    </div>
  </section>

  <section>
    <div>
      <a class="colored icon" routerLink="/usage-report" routerLinkActive="active">
        <svg-icon src="/assets/icons/usage-report.svg"></svg-icon>
        <span>Usage report</span>
      </a>
    </div>
  </section>
</div>

<ng-template #contact>
  <svg-icon class="icon" src="/assets/icons/mail.svg"></svg-icon>
  <span>Your information has been sent. We will contact you soon by e-mail</span>
</ng-template>
